import { clone } from "lodash";
import * as React from "react";
import { Link } from "react-router-dom";
import * as AccountStore from "./AccountStore";
import HumanJson from "../human";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Avatar from "react-avatar";
import axios from "axios";

const { Component } = React;

interface ProfileDataState {
    currentUser: any;
    user: any;
    humanJson: any;
    scadsysData: any;
    scadsysDataLoading: boolean;
    scadsysDataError: string | null;
    selectedOrganization: string;
}

export default class ProfileData extends Component<any, ProfileDataState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentUser: {},
            user: { twoFactorEnabled: false },
            humanJson: "",
            scadsysData: null,
            scadsysDataLoading: false,
            scadsysDataError: null,
            selectedOrganization: localStorage.getItem("organizationContext") || "",
        };
    }

    componentDidMount() {
        this.GetCurrentUser();
    }

    GetCurrentUser = () => {
        AccountStore.GetCurrentLoggedInUser(true).then((user) => {
            this.setState({
                currentUser: user,
                user: clone(user),
                humanJson: HumanJson.format(user.data || {}),
            });
        });
    };

    GetScadsysData = async () => {
        const { currentUser, selectedOrganization } = this.state;

        if (!currentUser.id || !selectedOrganization) {
            this.setState({ scadsysDataError: "Missing user ID or organization" });
            return;
        }

        this.setState({ scadsysDataLoading: true, scadsysDataError: null });

        try {
            const response = await axios.get("/api/users/getScadsysData", {
                params: {
                    userId: currentUser.id,
                    organizationId: selectedOrganization,
                },
            });

            if (response.data.Success) {
                this.setState({
                    scadsysData: response.data.Data,
                    scadsysDataLoading: false,
                });
            } else {
                this.setState({
                    scadsysDataError: "Failed to load Scadsys data: " + JSON.stringify(response.data.Errors),
                    scadsysDataLoading: false,
                });
            }
        } catch (error: any) {
            this.setState({
                scadsysDataError: error.message || "An error occurred while loading Scadsys data",
                scadsysDataLoading: false,
            });
        }
    };

    render() {
        const { scadsysData, scadsysDataLoading, scadsysDataError } = this.state;

        return (
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Header Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <div className="flex items-center gap-4">
                        <Avatar round={true} size="70" name={this.state.currentUser.fullName} src={this.state.currentUser.photo} />
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">
                                {this.state.currentUser.firstName} {this.state.currentUser.lastName}
                            </h1>
                            <h2 className="text-xl text-gray-600">{this.state.currentUser.email}</h2>
                            <p className="text-sm text-gray-500">{this.state.currentUser.userName}</p>
                        </div>
                    </div>
                </div>

                {/* Navigation Tabs */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
                    <nav className="flex space-x-4 px-6 py-3 border-b border-gray-200">
                        <Link to="/profile" className="px-3 py-2 text-sm font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50">
                            <FontAwesomeIcon icon={["fad", "user"]} className="mr-2" />
                            Profile
                        </Link>
                        <Link to="/profile/data" className="px-3 py-2 text-sm font-medium rounded-md text-blue-600 bg-blue-50 border-b-2 border-blue-600">
                            <FontAwesomeIcon icon={["fad", "database"]} className="mr-2" />
                            Data
                        </Link>
                        <Link to="/profile/scadsys" className="px-3 py-2 text-sm font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50">
                            <FontAwesomeIcon icon={["fad", "server"]} className="mr-2" />
                            Scadsys Data
                        </Link>
                        <Link to="/profile/mfa" className="px-3 py-2 text-sm font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50">
                            <FontAwesomeIcon icon={["fad", "shield-check"]} className="mr-2" />
                            MFA
                        </Link>
                        <Link to="/profile/security" className="px-3 py-2 text-sm font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50">
                            <FontAwesomeIcon icon={["fad", "lock"]} className="mr-2" />
                            Security
                        </Link>
                        <Link to="/profile/notifications" className="px-3 py-2 text-sm font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50">
                            <FontAwesomeIcon icon={["fad", "bell"]} className="mr-2" />
                            Notifications
                        </Link>
                    </nav>
                </div>
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                        <FontAwesomeIcon icon={["fad", "database"]} className="mr-2 text-purple-500" />
                        User Data
                    </h3>
                    <div className="prose max-w-none">
                        <div dangerouslySetInnerHTML={{ __html: this.state.humanJson.outerHTML }} />
                    </div>
                </div>
            </div>
        );
    }
}
